/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Next_UpInputs */

const th_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แข่งขันถัดไป`)
};

const en_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next up`)
};

const ja_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の試合`)
};

const zh_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一场`)
};

const es_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A continuación`)
};

const pt_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seguir`)
};

const id_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const fr_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À suivre`)
};

const tl_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod`)
};

const vi_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kế tiếp`)
};

const ko_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음`)
};

const de_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Nächstes`)
};

const ru_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const tr_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırada`)
};

const it_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossima`)
};

const pl_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny`)
};

const uk_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const hi_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const ar_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const ms_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seterusnya`)
};

const bn_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরবর্তী`)
};

const zh_tw2_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一場`)
};

const zh_hk2_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一場`)
};

const ur_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اگلا`)
};

const fa_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بعدی`)
};

const sw_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inayofuata`)
};

const nl_event_next_up = /** @type {(inputs: Event_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierna`)
};

/**
* | output |
* | --- |
* | "Next up" |
*
* @param {Event_Next_UpInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_next_up = /** @type {((inputs?: Event_Next_UpInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Next_UpInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_next_up(inputs)
	if (locale === "ja") return ja_event_next_up(inputs)
	if (locale === "zh") return zh_event_next_up(inputs)
	if (locale === "es") return es_event_next_up(inputs)
	if (locale === "pt") return pt_event_next_up(inputs)
	if (locale === "id") return id_event_next_up(inputs)
	if (locale === "fr") return fr_event_next_up(inputs)
	if (locale === "tl") return tl_event_next_up(inputs)
	if (locale === "vi") return vi_event_next_up(inputs)
	if (locale === "ko") return ko_event_next_up(inputs)
	if (locale === "de") return de_event_next_up(inputs)
	if (locale === "ru") return ru_event_next_up(inputs)
	if (locale === "tr") return tr_event_next_up(inputs)
	if (locale === "it") return it_event_next_up(inputs)
	if (locale === "pl") return pl_event_next_up(inputs)
	if (locale === "uk") return uk_event_next_up(inputs)
	if (locale === "hi") return hi_event_next_up(inputs)
	if (locale === "ar") return ar_event_next_up(inputs)
	if (locale === "ms") return ms_event_next_up(inputs)
	if (locale === "bn") return bn_event_next_up(inputs)
	if (locale === "zh-TW") return zh_tw2_event_next_up(inputs)
	if (locale === "zh-HK") return zh_hk2_event_next_up(inputs)
	if (locale === "ur") return ur_event_next_up(inputs)
	if (locale === "fa") return fa_event_next_up(inputs)
	if (locale === "sw") return sw_event_next_up(inputs)
	if (locale === "nl") return nl_event_next_up(inputs)
	return en_event_next_up(inputs)
});